export type NoResultsProps = {
  message?: string;
};

const NoResults = ({ message = 'No items' }: NoResultsProps) => {
  return <div>{message}</div>;
};

export default NoResults;
